import React, { useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../Config";
import Swal from "sweetalert2";
import QrScanner from "qr-scanner";

const getSpotRegistrationData = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/delegetListforCheckIn`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

const CheckInActivity = () => {
  const userRole = parseInt(sessionStorage.getItem("userRole"), 10);
  const navigate = useNavigate();
  const location = useLocation();

  const videoRef = useRef(null);
  const scannerRef = useRef(null);

  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    totalRecords: 0,
    currentPage: 1,
    totalPages: 1,
    pageSize: 25,
  });
  const [search, setSearch] = useState("");
  const [showScanner, setShowScanner] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const handlePageSizeChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const tabs =
    userRole === 3
      ? [
          {
            label: "Registration Request",
            path: "/review-list-of-spot-registration",
          },
          { label: "Badge Print/Assign", path: "/express-entry/badge-print" },
          { label: "Badge Assigned", path: "/express-entry/badge-assigned" },
          { label: "Check In Status", path: "/express-entry/check-in" },
        ]
      : userRole === 5
      ? [
          { label: "Badge Print/Assign", path: "/express-entry/badge-print" },
          { label: "Badge Assigned", path: "/express-entry/badge-assigned" },
          { label: "Check In Status", path: "/express-entry/check-in" },
        ]
      : userRole === 9
      ? []
      : [
          {
            label: "Registration Request",
            path: "/review-list-of-spot-registration",
          },
          { label: "Badge Print/Assign", path: "/express-entry/badge-print" },
          { label: "Badge Assigned", path: "/express-entry/badge-assigned" },
          {
            label: "Badge Re-Issue",
            path: "/express-entry/badge-reassigned",
          },
          { label: "Check In Status", path: "/express-entry/check-in" },
        ];

  const startScanner = async () => {
    setShowScanner(true);

    await new Promise((r) => setTimeout(r, 100));

    if (!videoRef.current) return;

    videoRef.current.disablePictureInPicture = true;
    videoRef.current.setAttribute("playsinline", true);

    scannerRef.current?.destroy();

    scannerRef.current = new QrScanner(
      videoRef.current,
      async (result) => {
        const scannedURL = result.data;
        console.log("Scanned:", scannedURL);
        scannerRef.current.stop();
        setShowScanner(false);

        try {
          const parts = scannedURL.split("/");
          const userId = parts[4]; // Adjust index based on QR structure

          if (!userId) {
            Swal.fire("Error", "Invalid QR Code", "error");
            return;
          }

          // const matchedUser = data.find((item) => item.id == userId);
          if (userId) {
            await insertActionActivity(userId);
          } else {
            Swal.fire("Error", "User not found in the list", "error");
          }
        } catch (err) {
          Swal.fire("Error", "Failed to process scanned data", "error");
        }
      },
      {
        returnDetailedScanResult: true,
        highlightScanRegion: true,
        highlightCodeOutline: true,
      }
    );

    scannerRef.current.start();
  };

  const stopScanner = () => {
    scannerRef.current?.stop();
    setShowScanner(false);
  };

  useEffect(() => {
    return () => {
      scannerRef.current?.destroy();
    };
  }, []);

  const fetchData = async () => {
    const payload = {
      page: pagination.currentPage,
      limit: pagination.pageSize,
      sortBy: "created_at",
      sortOrder: "desc",
      search: search,
    };

    try {
      const response = await getSpotRegistrationData(payload);
      setData(response.data || []);

      if (response.pagination) {
        setPagination(response.pagination);
      } else {
        setPagination((prev) => ({
          ...prev,
          totalRecords: response.data?.length || 0,
          totalPages: 1,
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.currentPage, pagination.pageSize, search, popupData]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const insertActionActivity = async (item) => {
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to Check In this Person?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, proceed",
      cancelButtonText: "Cancel",
    });

    if (!confirmation.isConfirmed) return;

    const payload = {
      userId: item,
      action_type: 31,
      date: new Date().toISOString(),
      Add_By_User: 1,
      Update_By_User: 1,
    };

    try {
      const res = await axios.post(`${BASE_URL}/insertActionActivity`, payload);
      setPopupData({
        ...payload,
        message: res.data.message || "Action recorded",
        dateTime: new Date().toLocaleString(),
      });
      Swal.fire("Success", res.data.message || "Action recorded", "success");
    } catch (e) {
      const msg = e.response?.data?.message || "Something went wrong!";
      Swal.fire("Error", msg, "error");
    }
  };
  const handleLogout = () => {
    // Clear user session or authentication data
    sessionStorage.clear(); // or localStorage.clear();

    // Redirect to the homepage
    navigate("/admin/login");
  };
  return (
    <div id="page" className="page">
      <div className="inner-page-wrapper">
        <section className="division wide-30">
          <div className="container">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 0",
              }}
            >
              <h2 style={{ margin: 0, fontSize: "24px", fontWeight: "bold" }}>
                EXPRESS ENTRY
              </h2>
              <div>
                <button
                  style={{
                    background: "#44929f",
                    padding: "6px 20px",
                    borderRadius: "40px",
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            </div>

            <div className="d-flex flex-wrap justify-content-center mt-4 mb-3 gap-3">
              {tabs.map((tab) => (
                <NavLink
                  key={tab.path}
                  to={tab.path}
                  className="fw-semibold text-decoration-none"
                  style={{
                    fontSize: "16px",
                    paddingBottom: "6px",
                    color: location.pathname === tab.path ? "#000" : "#000",
                    borderBottom:
                      location.pathname === tab.path ? "3px solid" : "none",
                  }}
                >
                  {tab.label}
                </NavLink>
              ))}
            </div>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "1rem",
                      }}
                    >
                      <h4 style={{ fontWeight: 700 }} className="font-bold">
                        Check In{" "}
                      </h4>
                      <button
                        onClick={startScanner}
                        style={{
                          fontWeight: 700,
                          backgroundColor: "#00BCD4",
                          padding: "5px 10px",
                          borderRadius: "5px",
                          color: "white",
                          border: "none",
                        }}
                        className="font-bold"
                      >
                        {showScanner
                          ? "Scanner Running..."
                          : "Check In By Scanner"}
                      </button>
                    </div>

                    {showScanner && (
                      <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex flex-col items-center justify-center">
                        <video
                          ref={videoRef}
                          className="w-80 h-80 object-cover rounded-lg shadow-xl border-4 border-white"
                          autoPlay
                          muted
                        />

                        <div className="mt-4 text-white text-lg font-semibold animate-pulse">
                          Scanning for QR...
                        </div>

                        <button
                          onClick={stopScanner}
                          className="absolute top-6 right-6 bg-red-600 hover:bg-red-700 transition text-white px-4 py-2 rounded-full shadow-lg"
                        >
                          ✕
                        </button>
                      </div>
                    )}
                    {/* Entries and Search UI */}
                    <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-3 mt-3 gap-3">
                      <div>
                        Show{" "}
                        <select
                          className="form-select d-inline-block w-auto border"
                          value={pagination.pageSize}
                          onChange={handlePageSizeChange}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                        </select>{" "}
                      </div>
                      <div className={` ${!isMobile ? "w-80" : "w-100"}`}>
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search..."
                          value={search}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>
                    {/* Table */}
                    <div className="table-responsive">
                      <table
                        id="request-list"
                        className="table table-bordered"
                        style={{ width: "100%" }}
                        data-order='[[0,"desc"]]'
                      >
                        <thead>
                          <tr className="text-center">
                            <th>Batch NO.</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Company</th>
                            <th>Category</th>

                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item) => (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.name}</td>
                              <td>{item.mobile}</td>
                              <td>
                                {item?.organization_name ||
                                  item?.deletegate_registation
                                    ?.organization_name ||
                                  "-"}
                              </td>
                              <td>
                                {item.deletegate_registation
                                  ?.deletegate_category || "-"}
                              </td>

                              <td>
                                {item?.actions?.[0]?.action_type === 31 ? (
                                  <span
                                    style={{
                                      backgroundColor: "#28a745",
                                      color: "#fff",
                                      padding: "8px 18px",
                                      borderRadius: "30px",
                                      fontSize: "0.85rem",
                                      fontWeight: "600",
                                      cursor: "no-drop",
                                      boxShadow:
                                        "0 2px 6px rgba(40, 167, 69, 0.4)",
                                      transition: "all 0.3s ease",
                                      display: "inline-block",
                                    }}
                                  >
                                    ✅ Checked In
                                  </span>
                                ) : (
                                  <span
                                    onClick={() =>
                                      insertActionActivity(item?.id)
                                    }
                                    style={{
                                      backgroundColor: "#007bff",
                                      color: "#fff",
                                      cursor: "pointer",
                                      padding: "8px 18px",
                                      borderRadius: "30px",
                                      fontSize: "0.85rem",
                                      fontWeight: "600",
                                      boxShadow:
                                        "0 2px 6px rgba(0, 123, 255, 0.4)",
                                      transition: "all 0.3s ease",
                                      display: "inline-block",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.backgroundColor =
                                        "#0056b3";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.backgroundColor =
                                        "#007bff";
                                    }}
                                  >
                                    🔍 Check In
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-5">
                      <div className="mb-3 mb-md-0">
                        Showing{" "}
                        {(pagination.currentPage - 1) * pagination.pageSize + 1}{" "}
                        to{" "}
                        {Math.min(
                          pagination.currentPage * pagination.pageSize,
                          pagination.totalRecords
                        )}{" "}
                        of {pagination.totalRecords} entries
                      </div>

                      <nav>
                        <ul className="pagination mb-0 flex-wrap">
                          {/* Previous button */}
                          <li
                            className={`page-item ${
                              pagination.currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange(pagination.currentPage - 1)
                              }
                              disabled={pagination.currentPage === 1}
                            >
                              Previous
                            </button>
                          </li>

                          {/* Page numbers with ellipsis */}
                          {Array.from(
                            { length: pagination.totalPages },
                            (_, i) => i + 1
                          )
                            .filter(
                              (page) =>
                                page === 1 ||
                                page === pagination.totalPages ||
                                (page >= pagination.currentPage - 2 &&
                                  page <= pagination.currentPage + 2)
                            )
                            .map((page, idx, arr) => {
                              const prevPage = arr[idx - 1];
                              const showEllipsis =
                                prevPage && page - prevPage > 1;
                              return (
                                <React.Fragment key={page}>
                                  {showEllipsis && (
                                    <li className="page-item disabled">
                                      <span className="page-link">…</span>
                                    </li>
                                  )}
                                  <li
                                    className={`page-item ${
                                      pagination.currentPage === page
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => handlePageChange(page)}
                                    >
                                      {page}
                                    </button>
                                  </li>
                                </React.Fragment>
                              );
                            })}

                          {/* Next button */}
                          <li
                            className={`page-item ${
                              pagination.currentPage === pagination.totalPages
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange(pagination.currentPage + 1)
                              }
                              disabled={
                                pagination.currentPage === pagination.totalPages
                              }
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CheckInActivity;
